import React, { useEffect, useMemo, useState, useRef } from 'react';
import useHeader from '../../hooks/useHeader';
import { useDispatch } from 'react-redux';
import {
  exploreMenuRequest,
  getRestaurantMenuDetails,
  setSelectedDeliveryType,
} from '../../common/features/restaurant/restaurantAction';
import {
  cartItemRequest,
  isScheduleOrderPlaceOrder,
  replacecartItems,
  resetCart,
  routeToLogin,
  setNotip,
  setSelectedDate,
  setTipAdded,
  toggleCartView,
} from '../../common/features/cart/cartActions';
// import accountsBack from "../../common/assets/svg/accountsBack.svg";
import Logouticon from '../../common/assets/svg/mdi_logout.svg';
// import calendar from "../../common/assets/svg/HeaderCalender.svg";
// import map from "../../common/assets/svg/header-map-pin.svg";
// import { ReactComponent as CartIcon } from "../../common/assets/svg/cartIcon.svg";
import userIcon from '../../common/assets/svg/profile-user.svg';
import checkOutBell from '../../common/assets/svg/checkOutBell.svg';
import { ReactComponent as CheckOutBell } from '../../common/assets/svg/checkOutBell.svg';
import { ReactComponent as UserIcon } from '../../common/assets/svg/profile-user.svg';
import { ReactComponent as ActiveUser } from './../../common/assets/svg/activeUser.svg';
import { ReactComponent as BackBtn } from '../../common/assets/svg/Backbtn.svg';
import { ReactComponent as HomeIcon } from '../../common/assets/svg/homePage.svg';
import { ReactComponent as Buzzer } from '../../common/assets/svg/buzzerIcon.svg';
import backBtnWhite from '../../common/assets/svg/Back.svg';
import { useLocation, useNavigate, useParams } from 'react-router';
import Signupnew from '../Signupnew/Signupnew';
import SwitchingorderType from '../SwitchingorderType/SwitchingorderType';
import { useSelector } from 'react-redux';
import { RestaurantMenuItem } from '../../common/features/restaurant/restaurantModels';
import { ORDER_STATUS_CODES, USER_DETAILS, USER_ID } from '../../common/constants';
import { clearGetOrderDetail } from '../../common/features/order/orderActions';
import { Helmet } from 'react-helmet-async';
import useRedirect from '../../hooks/useRedirct';
import { getCookie } from '../../helper/cookieHelper';
import { setSignupPopup as setSignupPopupAction } from '../../common/features/navigation/navigationActions';
import { getCdQsrOrderTypeGroup, isBuzzerFlowEnabled } from '../../common/utils/menu-helper-utils';

const BUZZER_FLOW_STORAGE_KEY = 'CONTACTLESS_BUZZER_FLOW';
const BUZZER_NO_STORAGE_KEY = 'CONTACTLESS_BUZZER_NO';

const MobileHeader = ({
  setPaymentStatus,
  setSignupPopup,
  setCardDelete,
  signupPopup,
  Switch,
  currentOrdertypeDetails,
  setCurrentOrdertypeDetails,
  menuType,
  handleBack,
  Logoutfn,
  NavigateProfile,
  GotoProfile,
  isMobile,
  isAccountPage,
  onLoginClick,
  selectedTab,
  setIsSearchActive,
  setShowMenuDrawer,
  notShowuserIcon,
  notShowBack,
  notshowHomeIcon,
  orderTrackingPage
}: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const source = searchParams.get('source');
  // `includes` (not `endsWith`) so this still matches once the Policies page's
  // in-page tab switch appends a slug, e.g. /account/Policies/PrivacyPolicy.
  const isPoliciesPage = location.pathname.includes('/account/Policies');
  const shouldHideHeaderActionsForSourcePolicies =
    isPoliciesPage && source === 'contactlessdinein';
    const redirect=useRedirect()
  const userName =( getCookie(USER_DETAILS) || {})?.firstName || '';
  const { merchantType, merchantSlug, tableId } = useParams();
  const slugDetails = useSelector((state: any) => state.persistedState.persistedRestaurantDetails);
  const isEventDate = useSelector((state: any) => state.cart.isEventDate);
   const eventName = useSelector((state: any) => state.persistedState?.eventDate);
   
   
  const eventDate = useSelector((state: any) => state.cart.eventDate);
  const storeTableId = useSelector((state: any) => state.persistedState.tableId)
  const dineInTableId = storeTableId;
  const selectedBuzzer = useSelector((state: any) => state.cart.selectedBuzzer);
  const selectedBuzzerFromStorage = useMemo(() => {
    const storedValue = localStorage.getItem(BUZZER_NO_STORAGE_KEY);
    if (storedValue == null) return null;
    const parsed = Number(storedValue);
    return Number.isFinite(parsed) ? parsed : null;
  }, [location.pathname]);



  const { orderTraking } = location.state || {};
  const cartItems = useSelector((state: any) => state?.cart?.cart?.items);

  const commonSuccess = (menuItems: RestaurantMenuItem[]) => {
    const menuItemMap = new Map(menuItems.map(item => [item.itemId, item]));

    // Modifier availability for the new order type is now validated at Checkout-click time
    // (Spinnerfooter's "Review Customizations" popup), which distinguishes mandatory vs optional
    // modifiers and lets the customer decide — so this no longer silently strips options here.
    // Just resync price/subTotal against the new order type's base price.
    const updatedCartItems = cartItems.map((cartItem: any) => {
      const matchedMenuItem = menuItemMap.get(cartItem.itemId);
      if (!matchedMenuItem) return cartItem;

      const optionTotal = (cartItem.options || []).reduce((sum: number, opt: any) => {
        return sum + (typeof opt.price === 'number' ? opt.price : 0);
      }, 0);

      const newPrice = parseFloat(matchedMenuItem.price);
      const quantity = parseFloat(cartItem.quantity);
      const newSubTotal = ((newPrice + optionTotal) * quantity).toFixed(2);

      return {
        ...cartItem,
        price: newPrice,
        subTotal: newSubTotal,
      };
    });

    dispatch(replacecartItems(updatedCartItems));
  };

  const {
    isCart,
    goBack,
    getImageURL,
    restaurantDetails,
    selectedDeliveryType,
    setCartItem,
    CartItemIds,
    basePath,
    setSwitchingOrderType,
    // tableId,
    orderDetails,
    orderInfo,
    handleLogoutclick,
    cdOrdersItems,
    showLogout,
    setShowLogout,
    switchingOrderType,
    cartData,
  } = useHeader({ handleBack, currentOrdertypeDetails, menuType, setCurrentOrdertypeDetails });
  
  const slugFromLocalStorage = localStorage.getItem('restaurant') && JSON.parse(localStorage.getItem('restaurant') || '');

  const isDineInOrder = restaurantDetails?.orderTypes?.some(
    (type: any) => type?.typeGroup === 'D' && type?.typeName === menuType
  );
  const isBuzzerEnabled = isBuzzerFlowEnabled(restaurantDetails);
  const isContactlessBuzzerEnabled = useMemo(() => {
    const isFlowFlagOn = localStorage.getItem(BUZZER_FLOW_STORAGE_KEY) === '1';
    const hasBuzzerNo =
      selectedBuzzer != null ||
      orderDetails?.buzzerNo != null ||
      localStorage.getItem(BUZZER_NO_STORAGE_KEY) != null;
    return Boolean(isBuzzerEnabled && (isFlowFlagOn || hasBuzzerNo));
  }, [isBuzzerEnabled, selectedBuzzer, orderDetails?.buzzerNo]);
  const suppressAuthPopupForBuzzerPayment = useMemo(() => {
    if (!isContactlessBuzzerEnabled) return false;
    const path = location.pathname || "";
    return path.includes("/placeOrder/payment") || path.includes("/checkOut");
  }, [isContactlessBuzzerEnabled, location.pathname]);
  const buzzerSeriesName = restaurantDetails?.uiFeatureFlags?.buzzerCountSeriesName || '';
  const formatBuzzerLabel = (n: number) => `${buzzerSeriesName}${String(n).padStart(2, '0')}`;
  const cdQsrOrderTypeGroup = getCdQsrOrderTypeGroup(restaurantDetails);
  const displayBuzzerLabel: string | null = (() => {
    if (selectedBuzzer != null) return formatBuzzerLabel(selectedBuzzer);
    if (orderDetails?.buzzerNo != null) {
      const asNum = Number(orderDetails.buzzerNo);
      return Number.isFinite(asNum) ? formatBuzzerLabel(asNum) : String(orderDetails.buzzerNo);
    }
    if (selectedBuzzerFromStorage != null) return formatBuzzerLabel(selectedBuzzerFromStorage);
    return null;
  })();
 const {menuType:menuTypeParams} = useParams<any>()
  const isOrderCompleteOrCancel = useMemo(() => {
    if (orderDetails) {
      return (
        orderDetails.status == ORDER_STATUS_CODES.ORDER_PICKED_UP ||
        orderDetails.status == ORDER_STATUS_CODES.ORDER_COMPLETE ||
        orderDetails.status == ORDER_STATUS_CODES.ORDER_CANCELLED_MERCHANT ||
        orderDetails.status == ORDER_STATUS_CODES.ORDER_CANCELLED_CUSTOMER
      );
    } else {
      return false;
    }
  }, [orderDetails]);



    
  const [shouldNotShowBackbtn, setShouldNotShowBackbtn] = useState(false);
  const globalShowSignupPopup = useSelector((state: any) => state?.navigation?.showSignupPopup);
  const [isGlobalTriggered, setIsGlobalTriggered] = useState(false);
  const prevGlobalStateRef = useRef(false);

  const handleLoginClick = () => {
    if (onLoginClick) {
      onLoginClick();
      return;
    }
    setIsGlobalTriggered(false);
    // Clear any pending enrollment intent — user is signing in independently
    sessionStorage.removeItem('pendingLoyaltyEnroll');
    if (setSignupPopup) setSignupPopup(true);
    setTimeout(() => {
      dispatch(setSignupPopupAction(true));
    }, 0);
  };

  // Listen to global Redux state for 403/401 errors
  useEffect(() => {
    if (suppressAuthPopupForBuzzerPayment) {
      if (globalShowSignupPopup) {
        dispatch(setSignupPopupAction(false));
      }
      setIsGlobalTriggered(false);
      if (setSignupPopup) {
        setSignupPopup(false);
      }
      prevGlobalStateRef.current = false;
      return;
    }

    // Only mark as globally triggered if state changes from false to true (new 403/401)
    if (globalShowSignupPopup && !prevGlobalStateRef.current) {
      setIsGlobalTriggered(true);
      // Also set local popup state when globally triggered
      if (setSignupPopup) {
        setSignupPopup(true);
      }
    } else if (!globalShowSignupPopup) {
      // When global state becomes false, reset the flag
      setIsGlobalTriggered(false);
      if (setSignupPopup) {
        setSignupPopup(false);
      }
    }
    prevGlobalStateRef.current = globalShowSignupPopup;
  }, [globalShowSignupPopup, setSignupPopup, suppressAuthPopupForBuzzerPayment, dispatch]);

  useEffect(() => {
    const pathname = location.pathname;
    const endsWithPrivacyPolicy = pathname.endsWith('PrivacyPolicy');
    const includesAccountOrPolicies = pathname.includes('account') || pathname.includes('policies');

    if (endsWithPrivacyPolicy && !includesAccountOrPolicies) {
      setShouldNotShowBackbtn(true);
    }
  }, [location.pathname]);

  const customerId = getCookie(USER_ID) || '';
  const currentUserDetail = useSelector((state: any) => state.user.currentUserDetail)

  const PickupOrderType = restaurantDetails?.orderTypes?.filter(
    (item: any) => item.typeGroup === 'P'
  );
  const DeliveryOrderType = restaurantDetails?.orderTypes?.filter(
    (item: any) => item.typeGroup === 'S'
  );
  const BothOrderTypeisnotAvailble =
    PickupOrderType &&
    !PickupOrderType[0]?.isEnabled &&
    DeliveryOrderType &&
    !DeliveryOrderType[0]?.isEnabled;

  const checkinTableId = localStorage.getItem('CHECKIN_TABLE_ID');
 

  const handleToggelSwitch = (type: string) => {
    dispatch(setSelectedDeliveryType(type));
    dispatch(isScheduleOrderPlaceOrder(false))
    setCartItem(true);
    setIsSearchActive&&setIsSearchActive(false);
    if(menuType?.toLowerCase() !== type?.toLowerCase()){
      dispatch(setNotip(""))
      dispatch(setTipAdded(false))
    }
    navigate(`${basePath}/${type}`);
    let payload = {
      type,
      locationId: restaurantDetails.id,
      customerId: customerId,
      searchText: null,
      visibleTo: "C",
      sagaSuccessCB: commonSuccess
    };
 
    dispatch(getRestaurantMenuDetails(payload));
    const currentPickUpOrderTypeId =
      restaurantDetails?.orderTypes?.find(
        (o: any) => o?.typeName === "Pickup"
      )?.id;

    const currentDeliveryOrderTypeId =
      restaurantDetails?.orderTypes?.find(
        (o: any) => o?.typeGroup === "S"
      )?.id;

    const cartItemObj = cartData?.map((item: any) => ({
      itemId: item?.itemId,
      modifierIds: item?.options?.map((modifier: any) => modifier?.typeId)
    }))

  const cartPayload = {
      itemIds: CartItemIds,
      itemObj: cartItemObj,
      orderTypeId: type==='Pickup' ? currentPickUpOrderTypeId : currentDeliveryOrderTypeId,
      locationId: restaurantDetails?.id
    };

    dispatch(cartItemRequest(cartPayload));
  }
  const [dishes, setDishes] = useState<RestaurantMenuItem[]>([]);
  
  const exploreMenu = useSelector(
    (state: any) => state.restaurant.exploreMenu?.menu
  );

  useEffect(() => {
    if (exploreMenu && exploreMenu?.length > 0) {
      setDishes([...exploreMenu]);
    }
  }, [exploreMenu]);

  // useEffect(() => {
  //   if (!exploreMenu && isMobile && restaurantDetails?.id && dishes?.length < 1 && menuType) {
  //     dispatch(
  //       exploreMenuRequest({
  //         locationId: restaurantDetails?.id,
  //         menuType: menuType,
  //       })
  //     );
  //   }
  // }, [restaurantDetails.id, menuType, slugFromLocalStorage?.location]);

  const isExploretabActive = useSelector((state: any) => state.restaurant.isExploretabActive)
 const acceptedLinksForIcon = location?.pathname?.includes('/account/DeliveryAddress') || location?.pathname?.includes('/account/Cards') ||
  location?.pathname?.includes('/account/MyOrders') || location?.pathname?.includes('/account/FAQ') || location?.pathname?.includes('/account/Favorites') ;


  useEffect(() => {
    const logoMedia = restaurantDetails?.orderSEO?.media?.find((m: any) => m.entityType === 'LOGO');
    if (!logoMedia) return;
    const logoUrl = `${process.env.REACT_APP_IMAGE_URL}img/${logoMedia.id}.${logoMedia.mimeType?.split('/')[1]}`;
    const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    if (favicon) {
      favicon.href = logoUrl;
      favicon.type = logoMedia.mimeType?.replace('img/', 'image/');
    } else {
      const newFavicon = document.createElement('link');
      newFavicon.rel = 'icon';
      newFavicon.href = logoUrl;
      newFavicon.type = logoMedia.mimeType?.replace('img/', 'image/');
      document.head.appendChild(newFavicon);
    }
  }, [restaurantDetails?.orderSEO?.media]);
   const seoData =
  (menuType &&
    restaurantDetails?.orderSEO?.[`${menuType.toLowerCase()}SEO`]) ||
  restaurantDetails?.seo;

const resLogo = restaurantDetails?.orderSEO?.media?.find(
  (m: any) => m.entityType === "LOGO"
);

const imageUrl = resLogo
  ? `${process.env.REACT_APP_IMAGE_URL}img/${resLogo.id}.${resLogo.mimeType?.split("/")[1]}`
  : seoData?.metaImage;
console.log({imageUrl});

const canonicalUrl =
  seoData?.metaUrl || seoData?.metaCanonical || window.location.href;

  return (
    <div
      className={`menu-page-header-new ${isDineInOrder && !dineInTableId ? 'dine-in-header' : ''} ${isContactlessBuzzerEnabled && tableId ? 'buzzer-header-mode' : ''}`}
    >
        {/* <Helmet>
              <meta name="keywords" content={restaurantDetails?.seo?.metaKeywords} />
              <meta name="robots" content={restaurantDetails?.seo?.metaTags} />
              <meta name="author" content={restaurantDetails?.seo?.metaAuthor} />
              <title>{seoData?.metaTitle}</title>
              <meta name="description" content={seoData?.metaDescription || restaurantDetails?.aboutUs || restaurantDetails?.restaurantName} />
              <meta name="keywords" content={seoData?.metaKeywords} />
              <meta name="robots" content={seoData?.metaTags || 'index,follow'} />
              <meta name="author" content={seoData?.metaAuthor} />
              <link rel="canonical" href={canonicalUrl} />
              <meta property="og:type" content="website" />
              <meta property="og:title" content={seoData?.metaTitle} />
              <meta property="og:description" content={seoData?.metaDescription || restaurantDetails?.aboutUs || restaurantDetails?.restaurantName} />
              <meta property="og:image" content={imageUrl} />
              <meta property="og:url" content={canonicalUrl} />
              <meta property="og:site_name" content={restaurantDetails?.restaurantName} />
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:title" content={seoData?.metaTitle} />
              <meta name="twitter:description" content={seoData?.metaDescription || restaurantDetails?.aboutUs || restaurantDetails?.restaurantName} />
              <meta name="twitter:image" content={imageUrl} />
              <link rel="icon" href={imageUrl} type={resLogo?.mimeType || 'image/png'} />
              <link rel="shortcut icon" href={imageUrl} type={resLogo?.mimeType || 'image/png'} />
            </Helmet> */}
    {/* <Helmet>
        <title>{(menuTypeParams && restaurantDetails?.orderSEO?.[`${menuTypeParams.toLowerCase()}SEO`]?.metaTitle) || restaurantDetails?.seo?.metaTitle}</title>
        <meta name="description" content={(menuTypeParams && restaurantDetails?.orderSEO?.[`${menuTypeParams.toLowerCase()}SEO`]?.metaDescription) || restaurantDetails?.seo?.metaDescription} />
        <meta name="keywords" content={restaurantDetails?.seo?.metaKeywords} />
        <meta name="robots" content={restaurantDetails?.seo?.metaTags} />
        <meta name="canonical" content={(menuTypeParams && restaurantDetails?.orderSEO?.[`${menuTypeParams.toLowerCase()}SEO`]?.metaUrl) || restaurantDetails?.seo?.metaCanonical} />
        <meta name="author" content={restaurantDetails?.seo?.metaAuthor} />
        <meta name="image" content={restaurantDetails?.orderSEO?.media?.find((m: any) => m.entityType === 'LOGO') ? `${process.env.REACT_APP_IMAGE_URL}img/${restaurantDetails.orderSEO.media.find((m: any) => m.entityType === 'LOGO').id}.${restaurantDetails.orderSEO.media.find((m: any) => m.entityType === 'LOGO').mimeType?.split('/')[1]}` : restaurantDetails?.seo?.metaImage} />
        {restaurantDetails?.orderSEO?.media?.find((m: any) => m.entityType === 'LOGO') && (
          <link rel="icon" href={`${process.env.REACT_APP_IMAGE_URL}img/${restaurantDetails.orderSEO.media.find((m: any) => m.entityType === 'LOGO').id}.${restaurantDetails.orderSEO.media.find((m: any) => m.entityType === 'LOGO').mimeType?.split('/')[1]}`} type={restaurantDetails.orderSEO.media.find((m: any) => m.entityType === 'LOGO').mimeType?.replace('img/', 'image/')} />
        )}
      </Helmet> */}
      {
        <div
          className="header-side-slot header-side-slot--left"
          style={notShowBack ? { minWidth: '50px' } : undefined}
        >
          {!shouldNotShowBackbtn && !notShowBack && (
            <>
              {isAccountPage ||
                (isCart && !menuType) ||
                (isDineInOrder && dineInTableId && location?.pathname?.includes('/order')) ||
                (location?.pathname?.includes('/feedbacks') && !dineInTableId) ||
                (location?.pathname?.includes('/placeOrder/payment') && !dineInTableId) ||
                location?.pathname?.includes('/order') ||
                (location?.pathname?.includes('/tracker') && !dineInTableId) ||
                (location?.pathname?.includes('/account') && !dineInTableId && !dineInTableId) ? (
                  <div className='Backbtn-new' 
                   
                  >
                      <BackBtn
                  className="homePageIcon-new"
                  style={{ width: '37px', height: '37px' }}
                  onClick={() => {
                    if (isDineInOrder) {
                      navigate(
                        `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${dineInTableId}/menu/${slugFromLocalStorage?.menuType}/contactlessdinein/landing`
                      );
                    } else if (setPaymentStatus) {
                      setPaymentStatus(true);
                    } else if (isOrderCompleteOrCancel && checkinTableId) {
                      localStorage.removeItem('CDUSER');
                      localStorage.removeItem('ACTIVE_ORDERS');
                      dispatch(clearGetOrderDetail());
                      if (isExploretabActive) {
                        navigate(
                          `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${checkinTableId}/menu/${slugFromLocalStorage?.menuType}/exploremenu`
                        );
                      } else {
                        navigate(
                          `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${checkinTableId}/menu/${slugFromLocalStorage?.menuType}`
                        );
                      }
                    } else if (location.pathname?.includes('/CD/feedbacks')) {
                      navigate(
                        `/restaurant/${slugDetails?.location}/table/${dineInTableId}/menu/${slugDetails?.menuType}`
                      );
                    } else if (orderTraking && !location.pathname?.includes('/tracker')) {
                      navigate(-1);
                    } else {
                      if (orderTrackingPage) {
                        // Coming back home after a completed payment: clear the
                        // finished order + cart so the menu/home page doesn't
                        // re-show the paid order's items. Refetch the menu
                        // without commonSuccess (which would re-hydrate the cart
                        // from the stale cartItems closure).
                        dispatch(resetCart());
                        dispatch(clearGetOrderDetail());
                        dispatch(getRestaurantMenuDetails({
      type:slugFromLocalStorage?.menuType,
      locationId: restaurantDetails.id,
      customerId: customerId,
      searchText: null,
      visibleTo: "C",
    }));
                      }
                      if (isMobile) {
                        navigate(-1);
                      } else {
                        if (isEventDate) {
                          navigate(
                            `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${slugFromLocalStorage?.menuType}/event/${eventName}`
                          );
                        } else {

                          navigate(
                            `/restaurant/${slugFromLocalStorage?.location}/menu/${slugFromLocalStorage?.menuType}`
                          );
                        }
                      }

                      // setTimeout(() => navigate(-1), 0);
                    }
                  }}
                 
                />

                  </div>
              
              ) : !isDineInOrder && !dineInTableId ? (
                <HomeIcon
                  className="homePageIcon-new"
                  style={{ width: '37px', height: '37px' }}
                  onClick={() => {
                    // setShowMenuDrawer(true);
                    navigate(`/${merchantType}/${merchantSlug}`);
                    if (setPaymentStatus) setPaymentStatus(true);
                  }}
                />
              ) : (
                <div className="homePageIcon-new"></div>
              )}
            </>
          )}
        </div>
      }

      <div
        className="restaurant-logo-container-new"
        style={{ marginLeft: shouldNotShowBackbtn ? '40px' : '' }}
      >
        {getImageURL('LOGO') && (
          <img
            src={getImageURL('LOGO')}
            alt="logo"
            className={
              isDineInOrder && !dineInTableId
                ? 'restaurant-logo-new-mobile-DineIn'
                : 'restaurant-logo-new-mobile'
            }
            title="Restaurant Logo"
          />
        )}
        {
          <span className="restaurant-branchName-new">
            {' '}
            {restaurantDetails.branchName?.split(',')[1]}, {restaurantDetails.state}
          </span>
        }
        {/* {(
          <span className="restaurant-branchName-new">
            {" "}
            {restaurantDetails.state}
          </span>
          
        )} */}
      </div>

      {Switch && (
        <>
          {
            <div className="toggle-container-new">
              <button
                className={` ${selectedDeliveryType === 'Pickup' ? 'active' : ''} 
                 ${BothOrderTypeisnotAvailble || (PickupOrderType && !PickupOrderType[0]?.isEnabled)
                    ? ''
                    : ''
                  } `}
                style={{
                  cursor: "pointer"
                  // PickupOrderType && PickupOrderType[0]?.isEnabled ? 'pointer' : 'default',
                }}
                disabled={isEventDate}
                onClick={() => {

                  handleToggelSwitch("Pickup")
                  dispatch(setSelectedDate(null))
                }}
              >
                {isEventDate
                  ? `${eventDate.replace(/-/g, ' ').charAt(0).toUpperCase()}${eventDate
                    .replace(/-/g, ' ')
                    .slice(1)} (Pickup)`
                  : 'Pickup'}
              </button>
              {isEventDate ? null : (
                <button
                  className={` ${selectedDeliveryType === 'Delivery' ? 'active' : ''}  ${BothOrderTypeisnotAvailble ||
                      (DeliveryOrderType && !DeliveryOrderType[0]?.isEnabled)
                      ? ''
                      : ''
                    } `}
                  style={{
                     cursor: "pointer"
                      // DeliveryOrderType && DeliveryOrderType[0]?.isEnabled ? 'pointer' : 'default',
                  }}
                  onClick={() => {
                    dispatch(setSelectedDeliveryType('Delivery'));
                      handleToggelSwitch("Delivery")
                      dispatch(setSelectedDate(null))
                  }}
                >
                  Delivery
                </button>
              )}
            </div>
          }
        </>
      )}

      {
        <div
          className={`${isMobile ? 'userIcon-container-mobile' : 'userIcon-container'} header-side-slot header-side-slot--right`}
        >
          {!acceptedLinksForIcon &&
            !shouldHideHeaderActionsForSourcePolicies &&
            !((location?.pathname?.includes('/account')) && !(location?.pathname?.includes('/Policies')) )&&
            !location?.pathname?.includes('/feedbacks') &&
            !shouldNotShowBackbtn && (
              <div>
                {
                  <div className="userIcon-container">
                    {
                    
                    (currentUserDetail?.firstName === '' || customerId) && dineInTableId ==="" && !isDineInOrder ? 

                    (
                      
                        !notShowuserIcon &&
                         <div className="active-user-withname">
                        <ActiveUser onClick={handleLogoutclick} className="active-user-icon-new" />
                        {<p className={isMobile ? 'loginText' : 'loginText-D'}>{userName}</p>}
                      </div>
                      
                     
                    ) :
                    
                    (
                      <>
                        {(!isDineInOrder || dineInTableId) &&
                          (dineInTableId  && isMobile? (
                            (() => {
                              const handleBellClick = () => {
                                if (dineInTableId && orderDetails && orderInfo) {
                                  navigate(
                                    `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${dineInTableId}/order/${orderInfo[0]?.orderId}`
                                  );
                                }
                                if (!dineInTableId) {
                                  handleLoginClick();
                                  setIsGlobalTriggered(false);
                                  if (setSignupPopup) setSignupPopup(true);
                                  setTimeout(() => {
                                    dispatch(setSignupPopupAction(true));
                                  }, 0);
                                }
                              };
                              if (isContactlessBuzzerEnabled && cdQsrOrderTypeGroup) {
                                return (
                                  <div className="header-buzzer-pill">
                                    <span className="header-buzzer-pill__number">
                                      {cdQsrOrderTypeGroup === 'P' ? 'Takeaway' : 'Dine In'}
                                    </span>
                                  </div>
                                );
                              }
                              return isContactlessBuzzerEnabled ? (
                                <div
                                  className="header-buzzer-pill"
                                >
                                  <Buzzer className="header-buzzer-pill__icon" />
                                  <span className="header-buzzer-pill__number">
                                    {displayBuzzerLabel ?? '--'}
                                  </span>
                                </div>
                              ) : (
                                <CheckOutBell
                                  title="User Icon"
                                  className="user-icon-new"
                                  onClick={handleBellClick}
                                />
                              );
                            })()
                          ) : (
                            !notShowuserIcon  && (
                              <UserIcon
                                title="User Icon"
                                className="user-icon-new"
                                onClick={() => {
                                  if (dineInTableId && orderDetails) {
                                    navigate(
                                      `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${dineInTableId}/order/${orderInfo[0]?.orderId}`
                                    );
                                  }
                                  if (!dineInTableId) {
                                    handleLoginClick();
                                  }
                                }}
                              />
                            )
                          ))}

                        {!dineInTableId && !isDineInOrder && !notShowuserIcon && !(location?.pathname?.includes('/Policies')) &&(
                          <p className="loginText">{'Login'}</p>
                        )}
                        {cdOrdersItems?.length > 0 && (
                          <div className="CD-orderCount">{cdOrdersItems?.length}</div>
                        )}
                      </>
                    )}
                  </div>
                }
              </div>
            )}
        </div>
      }

      {customerId && showLogout && (
        <div
          className="Log-out-Container"
          onClick={() => {
            Logoutfn();
            setShowLogout(false);
          }}
        >
          <img src={Logouticon} alt="" />
          <span className="logout-text">Log out</span>
        </div>
      )}

      {/* Only show local Signupnew if it's manually triggered (not from global 403/401) */}
      {signupPopup && !isGlobalTriggered && (
        <Signupnew
          isOpen={signupPopup}
          onClose={() => {
            if (setSignupPopup) {
              setSignupPopup(false);
                dispatch(setSignupPopupAction(false));
              dispatch(routeToLogin(false));
            }
          }}
        />
      )}
      {switchingOrderType && cartData?.length > 0 && (
        <SwitchingorderType
          isOpen={switchingOrderType}
          onClose={() => {
            setSwitchingOrderType(false);
            if (basePath) {
              if (selectedDeliveryType === 'Pickup') {
                dispatch(setSelectedDeliveryType('Delivery'));
                navigate(`${basePath}/Delivery`);
              } else if (selectedDeliveryType === 'Delivery') {
                dispatch(setSelectedDeliveryType('Pickup'));
                navigate(`${basePath}/Pickup`);
              }
            }
          }}
          currentOrdertypeDetails={currentOrdertypeDetails}
        />
      )}
    </div>
  );
};

export default MobileHeader;
